import { useState, ChangeEvent } from 'react'
import {
  ButtonGroup,
  Button,
  FormControl,
  Select,
  MenuItem,
  Box
} from '@material-ui/core'
import { RiRefreshLine } from 'react-icons/ri'
import { useStyles } from './styles'

interface RefreshOption {
  value: number
  label: string
}

interface RefreshControlProps {
  onRefresh: () => void
  onIntervalChange: (interval: number) => void
  defaultInterval?: number
}

const refreshOptions: RefreshOption[] = [
  { value: 0, label: 'Desligado' },
  { value: 15000, label: '15 segundos' },
  { value: 30000, label: '30 segundos' },
  { value: 60000, label: '1 minuto' },
]

const RefreshControl = ({
  onRefresh,
  onIntervalChange,
  defaultInterval = 15000
}: RefreshControlProps) => {
  const classes = useStyles()
  const [selectedInterval, setSelectedInterval] = useState(defaultInterval)

  const handleIntervalChange = (event: ChangeEvent<{ value: unknown }>) => {
    const newInterval = event.target.value as number
    setSelectedInterval(newInterval)
    onIntervalChange(newInterval)
  }

  const handleRefreshClick = () => {
    onRefresh()
  }

  return (
    <Box className={classes.container}>
      <ButtonGroup variant="outlined" className={classes.buttonGroup}>
        <FormControl variant="outlined" size="small" className={classes.formControl}>
          <Select
            value={selectedInterval}
            onChange={handleIntervalChange}
            displayEmpty
            className={classes.select}
          >
            {refreshOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          onClick={handleRefreshClick}
          variant="outlined"
          className={classes.refreshButton}
        >
          <Box className={classes.refreshIcon}>
            <RiRefreshLine size={20} />
          </Box>
        </Button>
      </ButtonGroup>
    </Box>
  )
}

export default RefreshControl
